import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle } from 'Constants/chart-config';

import {  
  mskVisualisationDetails
} from 'Actions';

class hipleftChartComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let hipleftlist= visualisationdetails.hipleft; 
    
    const data=hipleftlist.map((assmntval) => {  
          return {              
              name: assmntval.assessment,
              hipinternalright: assmntval.hipinternalright,
              hipinternalleft: assmntval.hipinternalleft,
              hipexternalright: assmntval.hipexternalright,
              hipexternalleft: assmntval.hipexternalleft
          }
    }); 
    return (
      
      <ResponsiveContainer width={this.props.data} height={400}>         
        <BarChart data={data}>
          <XAxis dataKey="name" stroke={ChartConfig.axesColor} />
          <YAxis stroke={ChartConfig.axesColor} domain={[0, 'dataMax + 5']}  />
          <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false} />
          <Legend />
          <Bar dataKey="hipinternalright" name="Right Hip Internal Rotation" fill={ChartConfig.color.leftshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="hipinternalleft" name="Left Hip Internal Rotation" fill={ChartConfig.color.rightshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="hipexternalright" name="Right Hip External Rotation" fill={ChartConfig.color.leftshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="hipexternalleft" name="Left Hip External Rotation"  fill={ChartConfig.color.rightshER} label={{ position: "top" }} barSize={20}/>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(hipleftChartComponent); 